import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  location: 'Rosario'
}, {
  name: 'Javier P.',
  location: 'Córdoba'
}, {
  name: 'Alejandro R.',
  location: 'Buenos Aires'
}, {
  name: 'Marcelo D.',
  location: 'Mendoza'
}, {
  name: 'Gustavo F.',
  location: 'Tucumán'
}, {
  name: 'Daniel S.',
  location: 'Neuquén'
}, {
  name: 'Pablo L.',
  location: 'Mar del Plata'
}, {
  name: 'Fernando G.',
  location: 'Salta'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[280px] md:max-w-[300px]" data-id="element-267">
      <div className="bg-brand-card rounded-lg shadow-2xl border-2 border-brand-accent p-3 flex items-start gap-2.5 relative overflow-hidden" data-id="element-268">
        <div className="bg-brand-accent/20 p-1.5 rounded-full shrink-0" data-id="element-269">
          <CheckCircle className="w-5 h-5 text-brand-accent" data-id="element-270" />
        </div>
        <div data-id="element-271">
          <p className="text-xs md:text-sm text-gray-200 font-medium leading-tight mb-0.5" data-id="element-272">
            <span className="font-bold text-white" data-id="element-273">{currentPurchase.name}</span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Digital ⚡
          </p>
          <p className="text-[10px] text-brand-accent font-bold" data-id="element-274">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-275">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}